import { State } from "core";
import { FocusableSection } from "@blacknut/spatialnav-sdk/dist";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import electronService from "../../services/ElectronService";
import { HeaderStyle } from "../../theme/Theme";
import { useTheme } from "../../theme/ThemeProvider";

import clsx from "clsx";
import styles from "./styles.module.scss";
import React from "react";
import { useAppNavigation } from "src/utils/Navigation/useAppNavigation";
interface HeaderProps {
  title?: string;
  headerRight?: JSX.Element;
  headerRightContainer?: JSX.Element;
  headerLeft?: JSX.Element;
  headerStyle?: Partial<HeaderStyle>;
  className?: string;
  hidden?: boolean;
}

const WebHeader = ({
  title,
  headerRight,
  headerLeft,
  headerStyle,
  className,
  hidden = false,
  headerRightContainer,
}: HeaderProps) => {
  const { theme } = useTheme();
  const { navigate } = useAppNavigation();
  const { organization } = useSelector((state: State) => state.globalState);
  const isVirginSub = organization?.name === "virgin_mobile";
  const isVivoSub = organization?.name === "vivo";

  const goToSlash = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <FocusableSection
      focusKey="header"
      component="header"
      className={clsx([
        styles.container,
        hidden && styles.hidden,
        electronService.getPlatform() === "darwin" && styles.darwin,
        className,
      ])}
      style={headerStyle}
    >
      {headerLeft && <div className={clsx(styles.leftContainer)}>{headerLeft}</div>}
      {!headerLeft && headerRight && <div />}

      {
        //FIXME check if still used
      }
      {title && !headerLeft && <div className={styles.title}>{title}</div>}

      {/* LOGO */}
      {title === undefined && (
        <div className={styles.logoContainer} onClick={goToSlash} data-testid="logo">
          {isVivoSub && (
            <ul className={styles.compoundLogo} data-testid="cobranding">
              {theme.images.Logo && (
                <li>
                  <theme.images.Logo
                    style={{
                      width: `${theme.logoSize.width}rem`,
                      height: `${theme.logoSize.height}rem`,
                    }}
                  />
                </li>
              )}
              {theme.images.LogoGameloft && (
                <li>
                  <theme.images.LogoGameloft
                    style={{
                      width: `10.6rem`,
                      height: `2.4rem`,
                    }}
                  />
                </li>
              )}
            </ul>
          )}
          {!isVivoSub && (
            <>
              {isVirginSub
                ? theme.images.LogoAIS && (
                    <span data-testid="logoGameloft">
                      <theme.images.LogoAIS
                        style={{
                          width: `${(theme as any).logoAISSize.width}rem`,
                          height: `${(theme as any).logoAISSize.height}rem`,
                        }}
                      />
                    </span>
                  )
                : theme.images.Logo && (
                    <theme.images.Logo
                      style={{
                        width: `${theme.logoSize.width}rem`,
                        height: `${theme.logoSize.height}rem`,
                      }}
                    />
                  )}
            </>
          )}
        </div>
      )}

      {headerRight && !headerRightContainer && (
        <div className={styles.rightContainer}>{headerRight}</div>
      )}
      {headerRightContainer}
    </FocusableSection>
  );
};

export default WebHeader;
